"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.videoStylesNamespace = exports.getDevices = exports.createVideoElement = void 0;
/*
 * DEPRECATED. This should be removed once the Encoder is converted to use player from core.
 */
const createVideoElement = (autoplay = true) => {
    // logger.debug("web/utils: createVideoElement() called");
    const video = document.createElement("video");
    video.autoplay = autoplay;
    video.muted = true;
    const fallbackText = document.createTextNode("Sorry, your browser doesn't support embedded videos.");
    video.appendChild(fallbackText);
    return video;
};
exports.createVideoElement = createVideoElement;
const getDevices = (deviceArray, inputType) => {
    return Array.isArray(deviceArray) && (inputType === "audio" || inputType === "video")
        ? deviceArray.filter((device) => device.kind === `${inputType}input`)
        : null;
};
exports.getDevices = getDevices;
exports.videoStylesNamespace = "video";
//# sourceMappingURL=helpers.js.map